import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import SeptumPiercingImage from '../../Assets/Piercing Services/septum piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function SeptumPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Septum Piercing UAE | 150-200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Septum Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Septum Piercing 150-200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={SeptumPiercingImage} alt="Septum Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Septum Piercing</h3>

          <p>
            Elevate your style with our professional septum piercing services in the UAE, available at an affordable price range of 150–200 AED. Septum piercing is a stylish and edgy choice that passes through the septum—the soft tissue between the nostrils—creating a bold yet versatile look. Perfect for those who want to stand out with a unique and fashionable statement, septum piercing has become a popular trend across modern fashion and self-expression. Whether you prefer a subtle ring or a more eye-catching piece of jewelry, our expert specialists ensure precise placement that enhances your facial features and complements your overall style.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and client comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each septum piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, reducing the risk of infection and ensuring a safe and smooth experience. Our goal is to provide a quick, efficient, and pain-minimized procedure, making septum piercing suitable for both first-time clients and those looking to expand their piercing collection.
          </p>

          <p>
            Septum piercing is known for its versatility, allowing you to switch between bold and minimal looks depending on your mood and style. It can be easily hidden when needed or showcased as a standout accessory, making it a flexible option for both personal and professional settings. Our specialists take the time to understand your preferences and guide you in selecting the ideal placement and jewelry type to achieve the best possible result.
          </p>

          <p>
            The procedure is typically completed within minutes, ensuring minimal discomfort and maximum convenience. Our team uses advanced techniques designed to reduce pain and promote faster healing, allowing you to enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensure a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that getting a septum piercing can feel intimidating, especially for first-timers, and our friendly staff is always available to answer questions and provide reassurance. From consultation to completion, we focus on delivering a positive and comfortable experience.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your septum piercing, and we provide detailed guidance to help you care for it properly. Our specialists will explain the best cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your septum piercing will heal smoothly and remain a long-lasting and stylish addition to your look.
          </p>

          <p>
            Our septum piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is simple and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted septum piercing services in the UAE for a safe, stylish, and professional experience. With experienced specialists, hygienic procedures, and a commitment to customer satisfaction, we help you achieve a bold and unique look effortlessly. Book your septum piercing appointment today and express your individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Septum Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SeptumPiercing;